import React from 'react'
import Preloader from '../../Global/Preloader';
import Headertwo from '../../Global/Headertwo';
import Servicebred from '../../Global/Servicebred';
import Abouttwo2 from '../../Home/Mainhomethree/Abouttwo2';
import Servicestwo from '../../Home/Mainhometwo/Servicestwo';
import Testimonialone from '../../Home/Mainhomeone/Testimonialone';
import Ctaone from '../../Global/Ctaone';
import Footer from '../../Global/Footer';
import BackToTop from '../../Global/BackToTop';
import Hero from '../../Global/Hero'
import Will4 from '../../Global/Will4'
import Will5 from '../../Global/Will5'


const Main = () => {
    return (
        <>
            {/* <Preloader /> */}
            <Headertwo />
            <Hero/>
            
            <Abouttwo2 />
            <Will4/>
            <Will5/>
            {/* <Servicestwo />
            <Testimonialone />
            <Ctaone /> */}
            <Footer />
            <BackToTop/>
        </>
    )
}
export default Main;